<div class="container">
    <div class="inner-container">
        <h1>Page Not Found</h1>
        <app-button
            [config]="{
                title: 'Back to Home',
                type: 'link',
                url: '/'
            }"
        ></app-button>
    </div>
</div>
